import { jsx as _jsx } from "react/jsx-runtime";
import { initializeMultipleSelectorState, MultipleSelectorStateActions, reduceMultipleSelectorState, TagInputSelector, } from '@dossierhq/design';
import { useEffect, useReducer } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
function useSynchronizeMultipleSelectorState(fieldSelector, items, selectedIds, dispatchSchemaEditorState) {
    const [state, dispatch] = useReducer(reduceMultipleSelectorState, { items, selectedIds }, initializeMultipleSelectorState);
    useEffect(() => {
        dispatchSchemaEditorState(new SchemaEditorActions.ChangeFieldAllowedComponentTypes(fieldSelector, state.selectedIds));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedIds]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.UpdateItems(items));
    }, [items]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.SetSelection(selectedIds));
    }, [selectedIds]);
    return { state, dispatch };
}
export function FieldComponentTypeSelector({ fieldSelector, componentTypes, schemaEditorState, dispatchSchemaEditorState, }) {
    const items = schemaEditorState.componentTypes.map((it) => ({ id: it.name }));
    const { state, dispatch } = useSynchronizeMultipleSelectorState(fieldSelector, items, componentTypes, dispatchSchemaEditorState);
    return (_jsx(TagInputSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.id }), state: state, dispatch: dispatch }));
}
//# sourceMappingURL=FieldComponentTypeSelector.js.map